import { requestPathname } from './routine-request-url';

/**
 * Detects a POST to the fetch-proxy endpoints (`ehq.fetch` from a step, and the
 * streaming download variant).
 *
 * EHQ-255: a 403 from these is not a statement about the user's access to the
 * application. The endpoint documents it as "URL blocked by SSRF protection" —
 * the egress policy refused the *target* the step asked for. Treating it as an
 * authorization failure raises a global Access Denied toast **and navigates the
 * user to /projects**, throwing them out of the project they were working in
 * over a step's choice of URL. The step's own error handling reports it.
 */
export function isFetchProxyRequest(url: string, method: string): boolean {
  if (method !== 'POST' && method !== 'post') {
    return false;
  }
  const path = requestPathname(url);
  return /\/fetch-proxy(-download)?$/.test(path);
}
